"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
var _BaseForm = _interopRequireDefault(require("react-platform-components/dist/BaseComponents/BaseForm"));
var _BaseInjectors = require("react-platform-components/dist/BaseComponents/BaseInjectors");
var _formFields = require("react-platform-components/dist/form-fields");
var _formValidators = require("react-platform-components/dist/form-validators");
var _mangopay_countries = require("react-platform-components/dist/helpers/mangopay_countries");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var getFormExtraFields = function getFormExtraFields() {
  return [/*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "owner_name",
    label: "Pr\xE9nom et nom du titutaire du compte",
    margin: "normal",
    variant: "outlined",
    type: "text",
    fullWidth: true,
    required: true,
    validate: (0, _formValidators.required)()
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "iban",
    label: "IBAN",
    margin: "normal",
    variant: "outlined",
    type: "text",
    fullWidth: true,
    required: true,
    validate: (0, _formValidators.required)()
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "bic",
    label: "BIC",
    margin: "normal",
    variant: "outlined",
    type: "text",
    fullWidth: true,
    required: true,
    validate: (0, _formValidators.required)()
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "address.address_line_1",
    label: "Adresse 01",
    margin: "normal",
    variant: "outlined",
    type: "text",
    fullWidth: true,
    required: true,
    validate: (0, _formValidators.required)()
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "address.address_line_2",
    label: "Adresse 02",
    margin: "normal",
    variant: "outlined",
    type: "text",
    fullWidth: true
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 5,
    className: "pr-4"
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "address.city",
    label: "Ville",
    margin: "normal",
    variant: "outlined",
    type: "text",
    fullWidth: true,
    required: true,
    validate: (0, _formValidators.required)()
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 4,
    className: "pr-4"
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "address.zipcode",
    label: "Code postal",
    margin: "normal",
    variant: "outlined",
    type: "text",
    fullWidth: true,
    required: true,
    validate: (0, _formValidators.required)()
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/_react.default.createElement(_formFields.Select, {
    variant: "outlined",
    fullWidth: true,
    required: true,
    validate: (0, _formValidators.required)(),
    label: "Pays",
    name: "address.country_code",
    margin: "normal"
  }, _mangopay_countries.countries && _mangopay_countries.countries.map(function (country, index) {
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: index,
      value: country['alpha-2']
    }, country.name);
  })))))];
};
var _default = (0, _BaseInjectors.injectToForm)(_BaseForm.default, {
  formExtraFields: function formExtraFields() {
    return getFormExtraFields();
  },
  handleInitialValues: function handleInitialValues() {
    return {
      'owner_name': '',
      'iban': '',
      'bic': '',
      'address': {
        'address_line_1': '',
        'address_line_2': '',
        'city': '',
        'zipcode': '',
        'country_code': ''
      }
    };
  }
});
exports.default = _default;